import { useMutation } from '@tanstack/react-query';
import { apiClient, requestBinary } from '../../lib/util';
import {
  EmployeeBulkInvitePreviewResponse,
  EmployeeBulkInviteRequest,
  PatchedEmployeeExtendedRequest,
  PatchedEmployeeGeneralDataRequest,
  PatchedEmployeePositionDataRequest
} from '@pxtra-client-lib-legacy/gen';

export function useSendEmployeeInvitation(options = {}) {
  return useMutation({
    mutationFn: (data: { id: string; employeeName?: string }) =>
      apiClient.employees.employeesSendInvitationEmailCreate({
        id: data.id
      }),
    ...options
  });
}

export function useDownloadEmployeeInvitationPdf(options = {}) {
  return useMutation<Blob, unknown, { id: string; filename?: string }>({
    mutationFn: (data) => requestBinary({ path: `/employees/${data.id}/invitation-pdf/` }),
    ...options
  });
}

export function useBulkInvitePreview(options = {}) {
  return useMutation<EmployeeBulkInvitePreviewResponse, unknown, EmployeeBulkInviteRequest>({
    mutationFn: (requestBody: EmployeeBulkInviteRequest) =>
      apiClient.employees.employeesBulkInvitePreviewCreate({ requestBody }),
    ...options
  });
}

export function useBulkInvite(options = {}) {
  return useMutation<Blob, unknown, EmployeeBulkInviteRequest>({
    mutationFn: (requestBody: EmployeeBulkInviteRequest) =>
      requestBinary({ path: '/employees/bulk-invite/', body: requestBody }),
    ...options
  });
}

export function useDeleteEmployee(options = {}) {
  return useMutation({
    mutationFn: (data: { id: string; employeeName?: string }) =>
      apiClient.employees.employeesDestroy({
        id: data.id
      }),
    ...options
  });
}

export function useUpdateEmployeeGeneralData(options = {}) {
  return useMutation({
    mutationFn: (data: { employeeId: string; requestBody: PatchedEmployeeGeneralDataRequest }) =>
      apiClient.employees.employeesGeneralDataPartialUpdate({
        id: data.employeeId,
        requestBody: data.requestBody
      }),
    ...options
  });
}

export function useUpdateEmployeePositionData(options = {}) {
  return useMutation({
    mutationFn: (data: { employeeId: string; requestBody: PatchedEmployeePositionDataRequest }) =>
      apiClient.employees.employeesPositionDataPartialUpdate({
        id: data.employeeId,
        requestBody: data.requestBody
      }),
    ...options
  });
}

export function useUpdateEmployeeExtendedData(options = {}) {
  return useMutation({
    mutationFn: (data: { employeeId: string; requestBody: PatchedEmployeeExtendedRequest }) =>
      apiClient.employees.employeesPartialUpdate({
        id: data.employeeId,
        requestBody: data.requestBody
      }),
    ...options
  });
}
